<!--<template>
  <div class="rent_main">
    <div class="vue-upload-img-multiple">
      <ul>
        <li v-show="image" v-for="(image,index) in imagesLrz" :key="index">
          <div class="img_size">
            &lt;!&ndash;<div :style="'backgroundImage:url('+image+')'" class="picture"></div>&ndash;&gt;
            <img class="picture" v-preview="image" :src="image" alt="">
            <span @click='delImage(index)' class="remove">x</span>
          </div>
        </li>
        <li v-show="showLoading">
          <img class="loading" src="../../common/images/loading.gif" alt="">
        </li>
        <li class="input-container">
          <input type="file" @change="onFileChange" accept="image/gif,image/jpeg,image/jpg,image/png"
                 class="file-input" ref="input">
        </li>
      </ul>
    </div>
    &lt;!&ndash;<div class="prompt">
      <span>（不能超过6张图片）</span>
    </div>&ndash;&gt;
  </div>
</template>
<style lang="scss">
  /*@import "../../common/sass/index.scss";*/
  @import "../../common/sass/base";

  .mint-indicator-mask {
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 667;
  }

  .rent_main {
    width: 100%;
    /*padding-top: 40px;*/
    background-color: #fff;
    .vue-upload-img-multiple {
      width: 100%;
      height: 100%;
      padding: 0 10px 10px;
      box-sizing: border-box;
      display: inline-block;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 25%;
          margin-top: 5px;
          text-align: center;
          .loading {
            display: block;
            margin: 0 auto;
            margin-top: 20px;
          }
          .img_size {
            display: inline-block;
            position: relative;
            .picture {
              width: 70px;
              height: 70px;
              float: left;
              border-radius: 4px;
              background-position: center center;
              background-repeat: no-repeat;
              background-size: cover;
            }
            .remove {
              position: absolute;
              top: -6px;
              right: -4px;
              width: 18px;
              height: 18px;
              z-index: 11;
              line-height: 18px;
              text-align: center;
              border-radius: 50%;
              // border-bottom: 1px solid #000;
              background-color: red;
              color: #fff;
              font-size: 15px;
            }
          }
        }
        .input-container {
          display: inline-block;
          background: url('../common/images/tianjiatupian@2x.png') no-repeat;
          width: 70px;
          height: 70px;
          background-size: 100% 100%;
          text-align: center;
        }
        .file-input {
          height: 70px;
          width: 70px;
          opacity: 0;
          font-size: 0;
        }
      }
    }
    .prompt {
      width: 100%;
      height: 30px;
      text-align: left;
      span {
        font-size: 13px;
        line-height: 30px;
        color: red;
        margin-left: 5px;
      }
    }
  }
</style>
<script>
  import {Toast} from 'mint-ui'
  import lrz from 'lrz'

  export default {
    data() {
      return {
        imagesLrz: [],
        showLoading: false
      }
    },
    created() {
//      console.log(this.holder)
    },
    methods: {
      onFileChange(e) {
        if (this.imagesLrz.length > 1) {
          Toast({
            message: '最多上传2张图片',
            position: 'middle',
            duration: 2000
          })
          return
        }
        let files = e.target.files || e.dataTransfer.files
        for (var i = 0; i < files.length; i++) {
          // console.log(files[i].size)
          // 限制图片上传的大小(2097152为2M)
          if (files[i].size > 3142656) {
            Toast({
              message: '请上传小于3M的图片',
              position: 'middle',
              duration: 3000
            })
            return
          }
        }
        if (!files.length) return
        this.createImage(files)
      },
      createImage(file, e) {
        this.showLoading = true
        lrz(file[0], {quality: 0.4})
          .then((rst) => {
            let img = new Image()
            img.src = rst.base64
            this.imagesLrz.push(rst.base64)
            this.$emit('getImage', this.imagesLrz)
            // return rst
            this.showLoading = false
          })
          .always(function () {
            // 清空文件上传控件的值
            e.target.value = null
          })
      },
      delImage(index) {
        this.imagesLrz.splice(index, 1)
        this.$refs.input.value = ''
      }
    }
  }
</script>-->
<template>
  <div class="ident_publish">
    <div class="vue-upload-img-multiple">
      <ul>
        <li v-show="image && !isIOS" v-for="(image,index) in images.localId" :key="index">
          <div class="img_size">
            <div :style="'backgroundImage:url('+image+')'" class="picture" @click="preview(index)"></div>
            <span @click='delImage(index)' class="remove">x</span>
          </div>
        </li>
        <li v-show="image && isIOS" v-for="(image,index) in images.iosLocalId" :key="index">
          <div class="img_size">
            <div :style="'backgroundImage:url('+image+')'" class="picture" @click="preview(index)"></div>
            <span @click='delImageIOS(index)' class="remove">x</span>
          </div>
        </li>
        <li class="input-container" @click="addImage()">
        </li>
      </ul>
    </div>
    <div class="prompt" v-show="desText">
      <span>（不能超过6张图片）</span>
    </div>
  </div>
</template>
<style lang="scss">
  /*@import "../../common/sass/index.scss";*/
  @import "../../common/sass/base.scss";

  .mint-indicator-mask {
    top: 0;
    left: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    opacity: 0.5;
    background: #000;
    z-index: 667;
  }

  .ident_publish {
    width: 100%;
    padding-top: 10px;
    background-color: #fff;
    .vue-upload-img-multiple {
      width: 100%;
      height: 100%;
      padding: 0 10px 10px;
      box-sizing: border-box;
      display: inline-block;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          width: 25%;
          margin-top: 5px;
          text-align: center;
          .loading {
            display: block;
            margin: 0 auto;
            margin-top: 20px;
          }
          .img_size {
            display: inline-block;
            position: relative;
            .picture {
              width: 70px;
              height: 70px;
              float: left;
              border-radius: 4px;
              background-position: center center;
              background-repeat: no-repeat;
              background-size: cover;
            }
            .remove {
              position: absolute;
              top: -10px;
              right: -8px;
              width: 18px;
              height: 18px;
              z-index: 11;
              line-height: 18px;
              text-align: center;
              border-radius: 50%;
              // border-bottom: 1px solid #000;
              background-color: red;
              color: #fff;
              font-size: 15px;
            }
          }
        }
        .input-container {
          display: inline-block;
          background: url('../common/images/tianjiatupian@2x.png') no-repeat;
          width: 70px;
          height: 70px;
          background-size: 100% 100%;
          text-align: center;
        }
        // .file-input {
        //   height: 70px;
        //   width: 70px;
        //   opacity: 0;
        //   font-size: 0;
        // }
      }
    }
    .prompt {
      width: 100%;
      height: 30px;
      text-align: left;
      span {
        font-size: 13px;
        line-height: 30px;
        color: red;
        margin-left: 2px;
      }
    }
  }
</style>
<script>
  import wx from 'weixin-js-sdk'
  import commonUrl from '../../common/js/commonUrl.js'
  import qs from 'qs'

  export default {
    data() {
      return {
        images: {
          localId: [],
          iosLocalId: []
        },
        maxSize: 0,
        ready: false,
        isIOS: false,
        serverId: []
      }
    },
    props: ['holder', 'desText'],
    created() {
      // 初始化JSConfig
      const urlLink = `${commonUrl.apihost}index.php/wx/wx_jssdk/getSignPackage`
      var data = {
        url: window.location.href.split('#')[0]
      }
      this.$http.post(urlLink, qs.stringify(data), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then(res => {
        if (res.data.code === 200) {
          wx.config({
            debug: false,
            appId: res.data.data.appId,
            nonceStr: res.data.data.nonceStr,
            rawString: res.data.data.rawString,
            signature: res.data.data.signature,
            timestamp: res.data.data.timestamp,
            jsApiList: ['chooseImage', 'previewImage', 'getLocalImgData', 'uploadImage']
          })
          this.ready = true
        }
      })
    },
    methods: {
      addImage() {
        if (this.ready) {
          var self = this
          var currentSize = this.images.localId.length
          if (self.isIOS) {
            if (this.images.iosLocalId.length > 1) {
              alert('图片不能超过2张')
              return
            }
          } else {
            if (this.images.localId.length > 1) {
              alert('图片不能超过2张')
              return
            }
          }
          wx.chooseImage({
            count: 2 - currentSize, // 默认9
            sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: (res) => {
              self.images.localId = self.images.localId.concat(res.localIds)
              if (window.__wxjs_is_wkwebview) {
                self.isIOS = true

                function readImages() {
                  wx.getLocalImgData({
                    localId: self.images.localId[currentSize],
                    success: function (res) {
                      var localData = res.localData
                      localData = localData.replace('jgp', 'jpeg')
                      self.images.iosLocalId.push(localData)
                      currentSize++
                      if (currentSize < self.images.localId.length) {
                        readImages()
                      }
                    },
                    fail: (res) => {
                      alert(res.errMsg)
                    }
                  })
                }

                readImages()
              }
              self._upload(currentSize)
            },
            fail: (err) => {
              console.log(err)
            }
          })
        }
      },
      _upload(i) {
        // var localId = localIds.shift()
        wx.uploadImage({
          localId: this.images.localId[i], // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: (res) => {
            i++
            this.serverId.push(res.serverId) // 返回图片的服务器端ID
            this.$emit('getImage', this.serverId)
            if (i < this.images.localId.length) {
              setTimeout(() => {
                this._upload(i)
              }, 100)
            }
          }
        })
      },
      delImage(index) {
        this.images.localId.splice(index, 1)
        this.serverId.splice(index, 1)
        this.$emit('getImage', this.serverId)
      },
      delImageIOS(index) {
        this.images.iosLocalId.splice(index, 1)
        this.images.localId.splice(index, 1)
        this.serverId.splice(index, 1)
        this.$emit('getImage', this.serverId)
      },
      preview(index) {
        wx.previewImage({
          current: this.images.localId[index], // 当前显示图片的http链接
          urls: this.images.localId // 需要预览的图片http链接列表
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/common/inchpublish1.vue